"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "Do you notice that your mind is trying to jump to conclusions or working hard to figure things out?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "Do you notice that your mind is trying to jump to conclusions or working hard to figure things out?"
  }
}, {
  prompt: "Are you collecting more and more information but never feeling like the issue you are trying to resolve is really ‘fixed’?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "Are you collecting more and more information but never feeling like the issue you are trying to resolve is really ‘fixed’?"
  }
}, {
  prompt: "Does it feel a bit like the situation is unsolvable but you still find yourself trying to solve it?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "Does it feel a bit like the situation is unsolvable but you still find yourself trying to solve it?"
  }
}, {
  prompt: "If you were able to solve the problem you are facing right now are you sure that the problem would fully go away or could a new problem arise?",
  type: "radio",
  options: ["The problem would be solved", "I can’t be sure that a solution would fix everything"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "If you were able to solve the problem you are facing right now are you sure that the problem would fully go away or could a new problem arise?"
  }
}, {
  prompt: "Is it possible that most people wouldn’t be able to solve this problem or maybe no one could fully solve the problem you are facing to the point of zero anxiety?",
  type: "radio",
  options: ["Most people could solve it", "Most people couldn’t totally solve it"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "Is it possible that most people wouldn’t be able to solve this problem or maybe no one could fully solve the problem you are facing to the point of zero anxiety?"
  }
}, {
  prompt: "Is it completely within your power to solve or are there a lot of moving factors that are causing the problem to shift over time?",
  type: "radio",
  options: ["It’s in my power to solve", "It’s a moving problem with changing factors"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "Is it completely within your power to solve or are there a lot of moving factors that are causing the problem to shift over time?"
  }
}, {
  prompt: "Can you turn your mind from resisting what’s happening towards accepting what is happening right now?",
  type: "radio",
  options: ["I’m trying that now", "I can’t seem to do it"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "Can you turn your mind from resisting what’s happening towards accepting what is happening right now?"
  }
}, {
  prompt: "Can you pay attention to what happens in your body if you commit to giving up any attempts to control or fix anything right now?",
  type: "radio",
  options: ["I’m checking in with how I feel when I give up on fixing", "I can’t seem to do it"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "Can you pay attention to what happens in your body if you commit to giving up any attempts to control or fix anything right now?"
  }
}, {
  prompt: "It’s normal to go in and out of acceptance but can you make a commitment to stop fighting ‘what is’ happening moment to moment?",
  type: "radio",
  options: ["I can try", "I can’t seem to do it"],
  batteryId: "CORONA_TOLERATING_UNCERTAINTY",
  meta: {
    summaryTitle: "It’s normal to go in and out of acceptance but can you make a commitment to stop fighting ‘what is’ happening moment to moment?"
  }
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;